var _rect, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStoreBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 50,
    viewBox: "0 0 162 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 50,
    rx: 8,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12, 10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26,
    height: 30,
    rx: 4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 20,
    height: 20,
    rx: 2,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 10,
    x2: 23,
    y2: 10,
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 16,
    x2: 23,
    y2: 16,
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 18,
    fontFamily: "Arial, sans-serif",
    fontSize: 8,
    fontWeight: 600,
    fill: "#FFFFFF",
    letterSpacing: "0.5px"
  }, "Download on the")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 33,
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#FFFFFF",
    letterSpacing: "0.5px"
  }, "App Store")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreBadge);
export default __webpack_public_path__ + "static/media/app-store-badge.53c6e8f83a383e03ac1796830ed0ce2b.svg";
export { ForwardRef as ReactComponent };